import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
  Typography,
  Box,
  DialogActions,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  progressContainer: {
    marginTop: 16,
    marginBottom: 16,
  },
  statsRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 12,
    flexWrap: "wrap",
    gap: 8,
  },
  statItem: {
    textAlign: "center",
    minWidth: 80,
  },
  statValue: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  statLabel: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  percentText: {
    marginTop: 4,
    textAlign: "center",
  },
}));

const ImportProgress = ({ open, onClose, progress }) => {
  const classes = useStyles();

  if (!progress) return null;

  const { action, total = 0, processed = 0, imported = 0, skipped = 0, errors = 0, validated = 0 } = progress;
  const percent = total > 0 ? Math.round((processed / total) * 100) : 0;
  const isDone = action === "done";

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        {isDone ? "Importação Concluída" : "Importando Contatos..."}
      </DialogTitle>
      <DialogContent>
        <div className={classes.progressContainer}>
          <LinearProgress
            variant="determinate"
            value={percent}
            color={isDone ? "primary" : "primary"}
          />
          <Typography className={classes.percentText} variant="body2">
            {processed} de {total} ({percent}%)
          </Typography>
        </div>

        <div className={classes.statsRow}>
          <div className={classes.statItem}>
            <div className={classes.statValue}>{imported}</div>
            <div className={classes.statLabel}>Importados</div>
          </div>
          <div className={classes.statItem}>
            <div className={classes.statValue}>{validated}</div>
            <div className={classes.statLabel}>Validados</div>
          </div>
          <div className={classes.statItem}>
            <div className={classes.statValue}>{skipped}</div>
            <div className={classes.statLabel}>Ignorados</div>
          </div>
          {errors > 0 && (
            <div className={classes.statItem}>
              <div className={classes.statValue} style={{ color: "#e74c3c" }}>{errors}</div>
              <div className={classes.statLabel}>Erros</div>
            </div>
          )}
        </div>
      </DialogContent>
      {isDone && (
        <DialogActions>
          <Button onClick={onClose} color="primary" variant="contained">
            Fechar
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ImportProgress;
